import * as yup from 'yup';
import { TFunction } from 'i18next';
import {
  LanguageCode,
  languageMap,
} from '../../../app/data/models/common/localizedLanguage';

export const menuValidationSchema = (
  t: TFunction,
  languageCodes: LanguageCode[]
) => {
  const titlesShape = languageCodes.reduce(
    (acc, code) => ({
      ...acc,
      [code]: yup
        .string()
        .required(
          t('menu.validation.title.required', { field: languageMap[code] })
        ),
    }),
    {}
  );

  return yup.object().shape({
    id: yup.string().optional(),
    titles: yup.object().shape(titlesShape),
  });
};
